import { LocationText } from '@/features/events/components/LocationText';
import { Flex, type FlexProps, Icon } from '@/ui';
import { useItemCardContext } from '../context/useItemCardContext';

export const Location = (props: FlexProps) => {
  const { entry, instance } = useItemCardContext();
  const locationWithPlace =
    instance?.locationWithPlace ?? entry.locationWithPlace;

  if (!locationWithPlace?.name) {
    return null;
  }

  return (
    <Flex align="flex-start" gap="2.5" {...props}>
      {/* Icon is tactically aligned to always appear centered with the first line of text even if the location wraps */}
      <Flex boxSize="20px" pos="relative" top="2px">
        <Icon icon="MapPin" size="18px" />
      </Flex>

      <LocationText lineHeight="22px" location={locationWithPlace} />
    </Flex>
  );
};
